import classnames from 'classnames';
import React from 'react';

const BaseScreenReader = (props)=>{
    const { children, className, tag: Tag = 'span', ...otherProps } = props;
    return /*#__PURE__*/ React.createElement(Tag, {
        ...otherProps,
        className: classnames('bf-screen-reader', className)
    }, children);
};

export { BaseScreenReader };
//# sourceMappingURL=base-screen-reader.js.map
